module.exports = __webpack_public_path__ + "img/mysql.32467178.svg";